/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {

    export class ClaimsAssignmentConfigurationService extends services.DataService<Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
            this.$q = $q;
        }

        public createClaimAssignmentConfiguration(): Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration>("ClaimsAssignmentConfiguration");
        }
        public getAllAssignmentWorkflowClaims(processConfigId: string): ng.IPromise<Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration[]> {
            var p1 = new breeze.Predicate("processConfiguration_id", "==", processConfigId);

            const query = this.breezeModule.EntityQuery
                .from("ClaimsAssignmentConfigurations")
                .expand("myClaimChild,myClaim")
                .where(p1);

            return this.executeQuery(query);
        }
        public getAllAssignmentConfigurationClaims(processConfigId: string, claimId: string): ng.IPromise<Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration[]> {
            var p1 = new breeze.Predicate("processConfiguration_id", "==", processConfigId);
            var p2 = new breeze.Predicate("claim_id", "==",claimId); 

            const query = this.breezeModule.EntityQuery
                .from("ClaimsAssignmentConfigurations")
                .expand("myClaimChild, assigningClaimValue, myCanBeAssignedCondition, myCanBeUnAssignedCondition")
                .where(p1.and(p2));

            return this.executeQuery(query);
        }
    }
}

warsApp.registerService('ClaimsAssignmentConfigurationService', ['breeze', '$q']);